import { createBrowserRouter } from 'react-router-dom';

import { RequireAuth } from '@/auth/require-auth';
import { CallbackPage } from '@/pages/callback';
import { DashboardPage } from '@/pages/dashboard';
import { NotFoundPage } from '@/pages/not-found';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireAuth>
        <DashboardPage />
      </RequireAuth>
    ),
  },
  {
    path: '/callback',
    element: <CallbackPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
